import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpCommonService} from './http-common.service';
import {LogoutResponse} from './interfaces/logout.interface';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  logout(): Observable<LogoutResponse> {
    const url = this.httpCommonService.makeUrl('/auth/logout');
    return this.http.post<LogoutResponse>(url, null);
  }
}
